var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'switch-container': true, 'switch-on': _vm.switchOn, 'switch-off': !_vm.switchOn },on:{"click":_vm.toggleSwitch}},[_c('div',{class:{ 'switch': true, 'on': _vm.switchOn, 'off': !_vm.switchOn }})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6294569d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/SwitchOnOff.vue
// module id = null
// module chunks = 